var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuiteCaseColorful = function SvgSuiteCaseColorful(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7903 13.7289C10.4313 13.7289 10.1403 14.0199 10.1403 14.3789C10.1403 14.7379 10.4313 15.0289 10.7903 15.0289V13.7289ZM13.2099 15.0289C13.5688 15.0289 13.8599 14.7379 13.8599 14.3789C13.8599 14.0199 13.5688 13.7289 13.2099 13.7289V15.0289ZM10.7903 15.0289H13.2099V13.7289H10.7903V15.0289Z",
    fill: "#ED7E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5559 8.25781V8.25781C5.55367 8.25781 4.74121 9.07027 4.74121 10.0725V16.5002C4.74121 17.6048 5.63664 18.5002 6.74121 18.5002H17.2587C18.3633 18.5002 19.2587 17.6048 19.2587 16.5002V10.0725C19.2587 9.07027 18.4462 8.25781 17.444 8.25781V8.25781",
    stroke: "#2F353B",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5L19 11.5",
    stroke: "#2F353B",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9125 9.25757C8.9125 9.61656 9.20351 9.90757 9.5625 9.90757C9.92149 9.90757 10.2125 9.61656 10.2125 9.25757H8.9125ZM13.7875 9.25757C13.7875 9.61656 14.0785 9.90757 14.4375 9.90757C14.7965 9.90757 15.0875 9.61656 15.0875 9.25757H13.7875ZM10.2125 9.25757V8.5H8.9125V9.25757H10.2125ZM11.5625 7.15H12.4375V5.85H11.5625V7.15ZM13.7875 8.5V9.25757H15.0875V8.5H13.7875ZM12.4375 7.15C13.1831 7.15 13.7875 7.75442 13.7875 8.5H15.0875C15.0875 7.03645 13.9011 5.85 12.4375 5.85V7.15ZM10.2125 8.5C10.2125 7.75442 10.8169 7.15 11.5625 7.15V5.85C10.0989 5.85 8.9125 7.03645 8.9125 8.5H10.2125Z",
    fill: "#ED7E00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuiteCaseColorful, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/suite-case-colorful.0b33744e.svg";
export { ForwardRef as ReactComponent };